<template>
  <el-card>
    <el-header>
      <span class="cadastro-title">Cópia de Metas em Lote </span>
      <a class="pull-right clickable" @click="doClose()"><i class="icon-close"></i></a>
    </el-header>
    <el-row>
      <el-col class="mt-2">
        <el-checkbox-group v-model="processosChecked" >
          <ul>
             <li v-for="processo in processoOptions">
               <el-checkbox  :label="processo.id" :key="processo.id">{{processo.label}}</el-checkbox>
             </li>
          </ul>
        </el-checkbox-group>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
          <el-button type="danger" class="pull-right" @click="atualizar">Atualizar</el-button>
      </el-col>
    </el-row>

  </el-card>
</template>

<script>
  import Page from "../../components/Page"

  export default {
    name: "MetaCopy",
    components: {Page},
    props: ['copyShow' , 'centroCustoId' , 'grupoId'],
    data(){
      return {
        checkAll : true,
        processoOptions: [
          {id : 1  , label : 'Árvore de Indicadores'},
          {id : 2  , label : 'Meta, Desafio e Partida'},
          {id : 3  , label : 'Pesos'},
        ],
        processosChecked: [1,2,3],
      }
    },
    methods: {
      doClose() {
        this.$emit('update:copyShow', false)
      },
      atualizar() {
          alert("Atualizar")
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Competencia/MetaCopy.vue